export default [
  { title: 'Lorem ipsum', done: false },
  { title: 'Dolor sit', done: true },
  { title: 'Amet consectetur', done: false },
  { title: 'Adipiscing elit', done: true }
];



// WEBPACK FOOTER //
// ./src/examples/todos.js